<template>
<svg viewBox="0 0 12 12" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-dict-code`]" width="1em" height="1em" v-bind="$attrs"><path d="M7.86768 0.875C8.87577 0.875 9.3801 0.875101 9.76514 1.07129C10.1037 1.24387 10.3787 1.51977 10.5513 1.8584C10.7473 2.24337 10.7476 2.74719 10.7476 3.75488V9.20801C10.7476 9.8798 10.7475 10.216 10.6167 10.4727C10.5016 10.6983 10.318 10.8821 10.0923 10.9971C9.83562 11.1277 9.49948 11.1279 8.82764 11.1279H5.09229C3.74842 11.1279 3.07633 11.1277 2.56299 10.8662C2.11147 10.6362 1.74426 10.2689 1.51416 9.81738C1.25261 9.30406 1.25244 8.63189 1.25244 7.28809V4.71484C1.25244 3.37095 1.2526 2.69889 1.51416 2.18555C1.74426 1.73401 2.11144 1.3668 2.56299 1.13672C2.83505 0.998123 3.15176 0.933942 3.58936 0.90332V4.84863L4.64404 4.24902L5.69873 4.84863V0.875H7.86768ZM3.40869 8.47363C3.11073 8.47386 2.86893 8.71572 2.86865 9.01367C2.86865 9.31186 3.11056 9.55348 3.40869 9.55371H8.59033C8.88866 9.55371 9.13037 9.312 9.13037 9.01367C9.13009 8.71558 8.88848 8.47363 8.59033 8.47363H3.40869Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillDictCode',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
